import React from "react";
import Menu from "./Menu";
import { useSector } from "./SectorContext";

function HeaderSection() {
  const { activeSector } = useSector();

  const scrollToExplore = () => {
    const nextSection = document.querySelector(".text-band");

    if (nextSection) {
      nextSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <section className="header-section header-blend">
        <div className="header-wrapper">
          <div className="header-text-container">
            <div className="header-text">
              <h1 className="main-header-text">
                {activeSector.mainHeaderText.map((line, index) => (
                  <React.Fragment key={index}>
                    {line.emphasized ? (
                      <strong className={activeSector.colorClass}>
                        {line.text}
                      </strong>
                    ) : (
                      <span>{line.text + " "}</span>
                    )}
                  </React.Fragment>
                ))}
              </h1>
            </div>

            <div className="header-subtext">
              {activeSector.mainHeaderSubtext}
            </div>

            <div className="accent-container">
              <div className="header-menu-container">
                <Menu />
              </div>

              <div className="image-container parallax-slow">
                <img
                  src={activeSector.accentImage.src}
                  alt={activeSector.accentImage.alt}
                  className="accent-image"
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>
          </div>

          <div className="header-image-container">
            <div className="header-image parallax-medium">
              <img
                src={activeSector.headerImage.src}
                alt={activeSector.headerImage.alt}
                className="man-image"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </div>
          </div>

          <button
            type="button"
            className="scroll-indicator"
            onClick={scrollToExplore}
            aria-label="Scroll to explore"
          >
            <span className="scroll-indicator-text">Explore</span>

            <span className="scroll-indicator-path" aria-hidden="true">
              <span className="scroll-indicator-arrow" />
            </span>
          </button>
        </div>
      </section>
    </>
  );
}

export default HeaderSection;
